import { useEffect } from 'react';
import useIsMobileScreen from 'hooks/useIsMobileScreen';
import { useSearchParams } from 'react-router-dom';
import { Location } from 'utils/windowUtils';
import LoginDesktop from './loginDesktop/LoginDesktop';
import LoginMobile from './loginMobile/LoginMobile';

const Login = () => {
  const isMobile = useIsMobileScreen();
  const [searchParams] = useSearchParams();
  const redirectUri = searchParams.get('redirectUri');
  const isMobileAppLogin = searchParams
    .get('clientId')
    ?.startsWith('pmpMobile_');
  const hasAccessToken = localStorage.getItem('access_token');

  useEffect(() => {
    // if the page is loaded in an iframe (possible redirection from a legacy jsp page), force rendering in the top window
    if (window.self !== window.top && window.top) {
      window.top.location.href = window.location.href;
    }
  }, []);

  useEffect(() => {
    if (hasAccessToken && redirectUri && !isMobileAppLogin) {
      Location.change(decodeURIComponent(redirectUri));
    }
  }, [hasAccessToken, isMobileAppLogin, redirectUri]);

  return isMobile ? <LoginMobile /> : <LoginDesktop />;
};

export default Login;
